/* FormControlType.enum.js */

/**
 * @typedef FormControlType
 * @enum {string}
 */
module.exports = {
    UNKNOWN: "unknown",
    TEXT: "text",
    BOOLEAN: "boolean",
    OBJECT: "object",
    ARRAY: "array",
    NUMBER: "number",
    ENUM: "enum",
    CHOICE_OPTIONS: "choice_options",
    SELECT_OPTIONS: "select_options",
    COMPLETE_OPTIONS: "complete_options",
    COMPLETE_ALL_TYPE: "complete_all_type",
    REF: "ref",
    REGEX: "regex",
    TAB_OBJECT: "tab_object",
    TAB_ARRAY: "tab_array",
    TAB_GROUP: "tab_group",
    NULL: "null",
};
Object.freeze(module.exports);
